export default "__VITE_ASSET__CRTFCM_B__"